<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-button
        class="btn btn-gradient-primary mb-1 mr-50 col-md-2"
        @click="$router.go(-1)"
      >
        <i class="fas fa-arrow-left mr-25" /> {{ $t('returnToList') }}
      </b-button>
      <b-button
        v-if="items.statusconfirm == 1"
        class="btn btn-gradient-danger mb-1 ml-25 mr-50 col-md-2"
        @click="deletedata()"
      >
        {{ $t('deleteItem') }}
      </b-button>
      <b-button
        v-if="items.statusconfirm == 2"
        class="btn btn-gradient-success mb-1 ml-25 mr-50 col-md-2"
        @click="Submit()"
      >
        {{ $t('approve') }}
      </b-button>
      <b-button
        v-if="items.statusconfirm == 2"
        class="btn btn-gradient-danger mb-1 ml-25 mr-50 col-md-2"
        @click="notapproved()"
      >
        {{ $t('key-35') }}
      </b-button>

      <b-row class="match-height">
        <b-col md="7">

          <div class="card">
            <div class="header-cardx p-2">
              <h3 class="mb-0">
                {{ $t('details') }} {{ items.itemnumber_text }}
              </h3>
            </div>

            <div class="p-2">
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('orderNumber') }} :
                    </template>

                    <p class="mt-50 font-weight-bolder">
                      {{ items.itemnumber_text }}
                    </p>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="items.statusconfirm != 1"
                  md="12"
                >
                  <b-form-group
                    label-for="h-requestnumber"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('key-36') }} :
                    </template>

                    <p class="mt-50 font-weight-bolder">
                      {{ items.request_text }}
                    </p>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('parcelCode') }} :
                    </template>
                    <div class="mt-50 font-weight-bolder">
                      <router-link
                        :to="{name : 'admin-tracking-edit', params: {id: items.id_postnumber}}"
                      >
                        {{ items.postnumber }}
                      </router-link>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('status') }} :
                    </template>
                    <p
                      v-if="items.statusconfirm == 0"
                      class="mt-50 mb-0 badge badge-light-secondary"
                    >
                      {{ $t('cancelled') }}
                    </p>
                    <p
                      v-if="items.statusconfirm == 1"
                      class="mt-50 mb-0 badge badge-light-danger"
                    >
                      {{ $t('noOwner') }}
                    </p>
                    <p
                      v-if="items.statusconfirm == 2"
                      class="mt-50 mb-0 badge badge-light-info"
                    >
                      {{ $t('pendingReview') }}
                    </p>
                    <p
                      v-if="items.statusconfirm == 3"
                      class="mt-50 mb-0 badge badge-light-success"
                    >
                      {{ $t('operationCompleted') }}
                    </p>
                  </b-form-group>
                </b-col>

                <b-col
                  v-if="items.statusconfirm != 1"
                  md="12"
                >
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('customerCode') }} :
                    </template>
                    <div class="mt-50 font-weight-bolder">
                      <router-link
                        :to="{name : 'admin-traking'}"
                      >
                        {{ items.username }}
                      </router-link>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col
                  v-if="items.statusconfirm != 1"
                  md="12"
                >
                  <b-form-group
                    label-for="h-filecus"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('key-37') }} :
                    </template>
                    <img
                      :src="GetImg('goodsconfirm_file', items.filecus)"
                      alt="Preview"
                      class=""
                      width="80"
                      height="60"
                      @click="showPicture(items.filecus)"
                    >
                    <vue-image-lightbox-carousel
                      ref="lightbox"
                      :show="showLightbox"
                      :images="images"
                      :show-caption="false"
                      @close="closeBox()"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  v-if="items.statusconfirm == 1"
                  md="12"
                >
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('active') }} :
                    </template>
                    <div class="mt-50">
                      <b-form-checkbox
                        v-model="items.active"
                        :value="true"
                        class="custom-control-success"
                        name="check-button"
                        switch
                        inline
                        @change="Checkedactive(items)"
                      />
                    </div>

                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('transactionDate') }} :
                    </template>
                    <p class="mt-50 mb-0 font-weight-bolder ">
                      {{ time(items.created_at) }}
                    </p>
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label-for="h-remark"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('remarks') }} :
                    </template>
                    <b-form-textarea
                      id="h-remark"
                      v-model="items.remark"
                      type="text"
                      @change="Checkedactive(items)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label-for="h-paecelCode"
                    label-cols="3"
                    label-cols-lg="3"
                    label-cols-md="3"
                  >
                    <template v-slot:label>
                      {{ $t('key-38') }} :
                    </template>
                    <div class="mt-2">
                      <app-timeline>
                        <app-timeline-item
                          v-if="items.come_thaiwarehouse"
                          :title="`${items.come_thaiwarehouse} : `+$t('arrivedThaiWarehouse')"
                          variant="success"
                        />

                        <app-timeline-item
                          v-if="items.out_chinesewarehouse"
                          :title="`${items.out_chinesewarehouse} : `+$t('exitWarehouse')"
                          variant="success"
                        />

                        <app-timeline-item
                          v-if="items.come_chinesewarehouse"
                          :title="`${items.come_chinesewarehouse} : `+$t('arrivedChinaWarehouse')"
                          variant="success"
                        />
                      </app-timeline>
                    </div>

                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>

        <b-col md="5">
          <div
            class="card"
          >
            <div class="header-cardx p-2">
              <h3 class="mb-0">
                {{ $t('attachmentList') }}
              </h3>
            </div>

            <div class="p-2">
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <span
                      v-for="imageOr in items.fileadmin"
                      :key="imageOr"
                      class="mr-1"
                    >
                      <img
                        :src="GetImg('goodsconfirm_file', imageOr)"
                        alt="img-document"
                        class="border"
                        height="100"
                        width="120"
                        @click="showPicture(imageOr)"
                      >

                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

          </div>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  // BFormFile,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
//  ValidationProvider
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import moment from 'moment-timezone'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    BRow,
    BCol,
    // ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormTextarea,
    BFormCheckbox,
    // BFormFile,
    BButton,
    AppTimeline,
    AppTimelineItem,
    VueImageLightboxCarousel,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      images: [],
      showLightbox: false,
      required,
      isActive: true,
      file: null,
      parcelCode: null,
      remark: null,
      parcelList: [
        {
          value: '1',
          text: '1',
        },
        {
          value: '2',
          text: '2',
        },
        {
          value: '3',
          text: '3',
        },
      ],
      ID: this.$route.params.id,
      items: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    time(data) {
      moment.locale('th')
      return moment(data).format('DD MMMM YYYY HH:mm:ss')
    },
    async getData() {
      try {
        const params = {
          ID: this.ID,
        }
        const { data: res } = await this.$http.get('/Goodsconfirm/getDataOne', { params })
        this.items = res
        console.log(res)
      } catch (err) {
        this.SwalError(err)
      }
    },
    deletedata() {
      this.$bvModal.msgBoxConfirm(`ต้องการลบรายการ ${this.items.itemnumber_text} ?`, {
        title: 'ยืนยันข้อมูล',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          const obj = {
            ID: this.ID,
          }
          this.$http.post('/Goodsconfirm/deleteData', obj)
            .then(() => {
              this.Success(`ลบรายการ ${this.items.itemnumber_text} เรียบร้อย`)
              this.$router.push({ name: 'admin-goodsconfirm' })
            })
            .catch(err => {
              this.SwalError(err)
            })
          // console.log(obj)
        }
      })
    },
    Submit() {
      this.$bvModal.msgBoxConfirm('ต้องการอนุมัติความเป็นเจ้าของ ?', {
        title: 'ยืนยันข้อมูล',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'warning',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          const timess = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          const obj = {
            // eslint-disable-next-line no-underscore-dangle
            _id: this.items._id,
            statusconfirm: 3,
            timeokay: timess,
          }
          this.$http.post('/Goodsconfirm/updata', obj)
            .then(() => {
              this.getData()
              this.Success('บันทึกข้อมูลเรียบร้อย')
            })
            .catch(err => {
              this.SwalError(err)
            })
        }
      })
    },
    notapproved() {
      this.$bvModal.msgBoxConfirm(`ต้องการไม่อนุมัติ ${this.items.itemnumber_text} ?`, {
        title: 'ยืนยันข้อมูล',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          const obj = {
            // eslint-disable-next-line no-underscore-dangle
            _id: this.items._id,
            statusconfirm: 0,
            active: false,
          }
          this.$http.post('/Goodsconfirm/updata', obj)
            .then(() => {
              this.getData()
              this.Success('บันทึกข้อมูลเรียบร้อย')
            })
            .catch(err => {
              this.SwalError(err)
            })
        }
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        // title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: `<h3 style="color: #141414">${this.$t('key-298')}</h3>`,
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },

    showAdd() {
      this.$bvModal.show('add-addr')
    },
    showModal() {
      this.name = null
      this.phone = null
      this.address = null
      this.province = null
      this.district = null
      this.subdistrict = null
      this.postalcode = null
      this.$bvModal.show('modal-1')
    },
    Checkedactive(data) {
      this.$http.post('/Goodsconfirm/updata', data)
        .then(() => {
          this.getData()
          this.Success('บันทึกข้อมูลเรียบร้อย')
        })
        .catch(err => {
          this.SwalError(err)
        })
    },
    showPicture(picture) {
      this.showLightbox = true
      const img = { path: this.GetImg('goodsconfirm_file', picture) }
      this.images.push(img)
    },
    GetImg(pathfile, filename) {
      if (!filename) return ''
      const matches = filename.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/)
      if (matches && matches.length === 3) {
        return filename
      }
      return `${this.$http.defaults.baseURL}/viewimg?pathfile=${pathfile}/${filename}`
    },
    closeBox() {
      this.showLightbox = false
      this.images = []
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
